import { Action, createReducer, on } from '@ngrx/store';
import {
	cleanCurrentMaquina,
	loadedCurrentMaquinaError,
	loadedCurrentMaquinaSuccess,
	loadedCurrentReportesChartDataSuccess,

	updateCurrentMaquinaFilter,
	updateFiltrosSeleccionadosFormEstadisticaBornout,
	updateFiltrosSeleccionadosFormEstadisticaLineal,
	updateFiltrosSeleccionadosFormEventos
} from './reporte.actions';
import { IMaquinaInformeState, initialReporteState } from './reporte.state';

const reducer = createReducer(
	initialReporteState,
	on(loadedCurrentMaquinaSuccess, (state, payload) => ({
		...state,
		informeMaquina: payload.informeMaquina,
	})),
	on(loadedCurrentMaquinaError, (state, payload) => ({
		...state,
		errors: payload.error,
	})),
	on(updateCurrentMaquinaFilter, (state, payload) => ({
		...state,
		form: payload.form,
	})),
	on(updateFiltrosSeleccionadosFormEstadisticaBornout, (state, payload) => ({
		...state,
		formReporte: payload.form,
	})),
	on(updateFiltrosSeleccionadosFormEstadisticaLineal, (state, payload) => ({
		...state,
		formReporteVelocidad: payload.form,
	})),
	on(updateFiltrosSeleccionadosFormEventos, (state, payload) => ({
		...state,
		formReporteEvento: payload.form,
	})),
	on(loadedCurrentReportesChartDataSuccess, (state, payload) => ({
		...state,
		reportes: payload.reportes,
	})),
	on(cleanCurrentMaquina, () => ({
		...initialReporteState,
	}))
);

export function maquinaInformeReducer(
	state: IMaquinaInformeState = initialReporteState,
	action: Action
): IMaquinaInformeState {
	return reducer(state, action);
}
